import type { AffiliateAgreementView } from '@/api/generated';

export type AffiliateStatus = 'APPLIED' | 'ACTIVE' | 'PAUSED' | 'ENDED';
export type PayoutReadiness = 'taxDocsPending' | 'ready' | 'manual';

/**
 * PENDING → taxDocsPending; STRIPE_CONNECT* + COLLECTED/NOT_REQUIRED → ready;
 * MANUAL → manual.
 */
export function payoutReadiness(agreement: AffiliateAgreementView | undefined): PayoutReadiness {
  if (agreement?.taxDocsStatus === 'PENDING') return 'taxDocsPending';
  const method = agreement?.payoutMethod;
  const tax = agreement?.taxDocsStatus;
  if (
    (method === 'STRIPE_CONNECT' || method === 'STRIPE_CONNECT_MANUAL') &&
    (tax === 'COLLECTED' || tax === 'NOT_REQUIRED')
  ) {
    return 'ready';
  }
  return 'manual';
}

export function countLiveAffiliates(
  rows: Array<{ status?: AffiliateStatus }>,
): number {
  return rows.filter((row) => row.status === 'ACTIVE' || row.status === 'APPLIED').length;
}
